import React from "react";
import { startConsolidationCapture } from "../utils/consolidationCaptures.js";

// Captures actives seulement sous la page Consolidation (DispatchDays) : le relevé de l'écran Geotab n'en crée aucune.
const ConsolidationCaptureContext = React.createContext(null);
// openings : dernière ouverture capturée de chaque relevé pendant la session de page, parent de la réponse « Qui a conduit ? ».
const ACTIVE = { start: startConsolidationCapture, openings: new Map() };

export function ConsolidationCaptureProvider({ children }) {
  return React.createElement(ConsolidationCaptureContext.Provider, { value: ACTIVE }, children);
}

export default function useConsolidationCapture() {
  return React.useContext(ConsolidationCaptureContext);
}
